import { apiService } from "../store";
import { messageError, scheduleRequest } from "./index";
import { getUser } from "./auth";
import { childRequested } from "./child";

export const invoiceLoaded = (invoice) => {
  return {
    type: "INVOICE_LOADED",
    payload: invoice,
  };
};
export const invoicesLoading = (bool) => {
  return {
    type: "INVOICES_LOADING",
    payload: bool,
  };
};
export const invoicesRequest = (invoices) => {
  return {
    type: "INVOICES_REQUEST",
    payload: invoices,
  };
};

export const invoiceDataRequest = (invoice) => {
  return {
    type: "INVOICE_DATA_REQUEST",
    payload: invoice,
  };
};
export const stateInvoice = (state) => {
  return {
    type: "STATE_INVOICE",
    payload: state,
  };
};
export const changeStatusTraining = () => {
  return {
    type: "CHANGE_STATUS_TRAINING",
  };
};

export const invoiceToPay =
  (id, comment = "") =>
  (dispatch) => {
    apiService
      .invoiceToPay(id, comment)
      .then(() => {
        dispatch(invoiceRequest(id));
      })
      .catch((err) => {
        dispatch(messageError(err.response.data.message));
      });
  };
export const invoiceState = () => (dispatch) => {
  apiService.invoiceState().then((data) => {
    dispatch(stateInvoice(data));
  });
};

export const invoiceRequest = (id) => (dispatch) => {
  dispatch(invoicesLoading(true));
  apiService
    .getInvoice(id)
    .then((data) => {
      dispatch(invoiceDataRequest(data));
      dispatch(invoicesLoading(false));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
      dispatch(invoicesLoading(false));
    });
};
export const updateStateChildTrainingForInvoice =
  (id, invoice_id, payload) => (dispatch) => {
    dispatch(changeStatusTraining());
    apiService
      .updateStateChildrenTraining(id, payload)
      .then(() => {
        apiService.getInvoice(invoice_id).then((data) => {
          dispatch(invoiceDataRequest(data));
        });
      })
      .catch((err) => {
        dispatch(messageError(err.response.data.message));
      });
  };
export const invoicesRequested = (payload) => (dispatch) => {
  dispatch(invoicesLoading(true));
  apiService
    .invoicesRequest(payload)
    .then((data) => {
      dispatch(invoicesRequest(data));
      dispatch(invoicesLoading(false));
    })
    .catch((err) => {
      dispatch(invoicesLoading(false));
      dispatch(messageError(err.response.data.message));
    });
};

export const createInvoice = (invoice) => (dispatch) => {
  apiService
    .invoiceCreate(invoice)
    .then((data) => {
      dispatch(invoiceLoaded(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const createInvoiceAdmin = (invoice) => (dispatch) => {
  apiService
    .invoiceCreate(invoice)
    .then((data) => {
      dispatch(invoiceLoaded(data));
      if (!invoice.estimation) {
        apiService.childRequest(invoice.children_id).then((data) => {
          dispatch(childRequested(data));
        });
      }
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const payToInvoice = (id) => (dispatch) => {
  apiService
    .payInvoice(id)
    .then((data) => {
      window.open(`${data.form_link}`, "_self");
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const deleteBankingToInvoice = (id) => (dispatch) => {
  apiService
    .invoiceDeleteBankingHistory(id)
    .then(() => {
      apiService.getInvoice(id).then((data) => {
        dispatch(invoiceDataRequest(data));
      });
      dispatch(getUser());
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const createInvoiceForTrainer = (invoice) => (dispatch) => {
  return apiService
    .invoiceCreate(invoice)
    .then((data) => {
      dispatch(invoiceLoaded(data));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
export const createInvoiceForClient = (invoice) => (dispatch) => {
  apiService
    .invoiceCreate(invoice)
    .then((data) => {
      dispatch(invoiceLoaded(data));
      if (data.id) {
        dispatch(getUser());
        dispatch(invoiceLoaded([]));
      }
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
      dispatch(invoiceLoaded([]));
    });
};
export const deleteInvoice = (id) => (dispatch) => {
  apiService.invoiceDelete(id).catch((err) => {
    dispatch(messageError(err.response.data.message));
  });
};
export const trainingMoveInvoice = (payload) => (dispatch) => {
  apiService
    .invoiceTrainingMove(payload)
    .then(() => {
      dispatch(getUser()).then(() => {
        dispatch(scheduleRequest(payload.schedule_to_id));
      });
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};

export const trainingMoveInvoiceForAdmin = (payload) => (dispatch) => {
  apiService
    .invoiceTrainingMove(payload)
    .then(() => {
      dispatch(invoiceRequest(payload.id));
    })
    .catch((err) => {
      dispatch(messageError(err.response.data.message));
    });
};
